import { motion } from "framer-motion";
import { Plus, Bike } from "lucide-react";
import { TOPPINGS } from "../data/menu";
import { BUSINESS } from "../data/business";
import { ChapterHeader, Reveal } from "./Reveal";

export const Toppings = () => (
  <section id="prilozi" className="relative py-28 sm:py-40 bg-paper2 border-y border-black/5 overflow-hidden" data-testid="toppings-section">
    <div className="absolute -bottom-32 left-[-10%] w-[45vw] h-[45vw] rounded-full bg-leaf/12 blur-[120px] pointer-events-none" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
      <ChapterHeader
        number="03"
        title={<>20 priloga. <span className="text-leaf">Tvoj izbor.</span></>}
        sub="Za lepinje i porcije — nađi svoju kombinaciju, pa je brani. Od pavlake i tzatzikija do ljute tucane paprike."
      />

      <div className="flex flex-wrap gap-3" data-testid="toppings-grid">
        {TOPPINGS.map((t, i) => (
          <motion.span
            key={t}
            initial={{ opacity: 0, scale: 0.85 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ delay: i * 0.035, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            whileHover={{ rotate: -2, scale: 1.06 }}
            data-testid={`topping-${t.toLowerCase().replace(/\s+/g, "-")}`}
            className="cursor-default flex items-center gap-2 bg-white border border-leaf/25 rounded-full px-5 py-2.5 text-sm text-leafdark hover:border-leaf hover:bg-leaf hover:text-white hover:font-semibold transition-colors duration-300"
          >
            <Plus className="w-3.5 h-3.5 text-chili" />
            {t}
          </motion.span>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-14 rounded-[1.75rem] border border-chili/30 bg-white p-8 sm:p-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 shadow-[0_24px_60px_-30px_rgba(220,47,35,0.3)]">
          <div>
            <p className="font-display font-extrabold uppercase text-2xl sm:text-3xl text-ember leading-tight">
              Gladan <span className="text-leafdark">upravo sada?</span>
            </p>
            <p className="text-leafdark text-base mt-3 max-w-lg">
              Poruči za par klikova — dostavu vrše Glovo i Wolt, brzo i vrelo na tvoju adresu.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 shrink-0">
            <a
              data-testid="toppings-glovo-btn"
              href={BUSINESS.glovo}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-ember text-white font-bold text-sm uppercase tracking-wide rounded-full px-8 py-4 hover:bg-emberglow transition-colors duration-300"
            >
              <Bike className="w-4 h-4" /> Naruči preko Glovo-a
            </a>
            <a
              data-testid="toppings-wolt-btn"
              href={BUSINESS.wolt}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 border-2 border-leaf text-leafdark font-bold text-sm uppercase tracking-wide rounded-full px-8 py-[14px] hover:bg-leaf hover:text-white transition-colors duration-300"
            >
              Naruči preko Wolt-a
            </a>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
